<div class="modal-header">
    <h4 class="modal-title pull-left">Add to Exchange</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="form-group">
        <div *ngFor="let item of exchangeCodes;let i = index">
            <label class="custom-checkbox">
                <input type="checkbox" (change)="onSelect($event,item.Id)">
                {{item.ExchangeCode}}
                <i></i>
            </label>
        </div>
    </div>
    <div class="text-right">
        <button class="btn btn-default btn-lg" type="button" id="closeModal" (click)="modalRef.hide();">Cancel</button>
        <button class="btn btn-success btn-lg" (click)="onSubmit();">Save</button>
    </div>
</div>